module.exports = __webpack_public_path__ + "media/images/login_bg_02-16be46b03973b5de17080d512d1ccccf.jpg";